import React from 'react';

import type { DropdownOption } from './types/DropDownTypes';

type DropdownOptionsProps = {
  options?: DropdownOption[];
};

const DropdownOptions: React.FC<DropdownOptionsProps> = ({
  options,
}) => {
  if (!options) {
    return null;
  }

  return (
    <>
      {options.map((option: DropdownOption) => (
        <option
          key={option.value}
          value={option.value}
          className={option.className}
        >
          {option.label}
        </option>
      ))}
    </>
  );
};

export default DropdownOptions;
